// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
// Import the styles directly. (Or you could add them via script tags.)
/* eslint-disable */
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap-vue/dist/bootstrap-vue';

import './assets/js/polyfill';
import 'classlist-polyfill';

import App from './App';
import router from './router';
import {Preloader} from './assets/js/preloader';
import {ConfigMgr} from './assets/js/configMgr';
import {Animations} from './assets/js/animation';
import {EventBus} from "./assets/js/event-bus";
import {store} from './store/store';
import {detect} from 'detect-browser';

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

// Global data store for key value storage
// An extremely simplified way to control resources
window.dataStore = new Object();  // keep track of caches
window.loadSpinner = false;       // help enable spinner
window.routeHistory = [];         // keep track of route history
window.fromRoute = '';
window.toRoute = '';

// Global utilities
window.configMgr = ConfigMgr;
window.preloader = Preloader;
window.animations = Animations;
window.eventBus = EventBus;

// This is a kludge for this app to work with Chris Gordon Adobe Analytic page tracking
window.firstLaunch = true;
// video.js
window.HELP_IMPROVE_VIDEOJS = false;

// fetch configuration file and only after the config file is fetch, then
// we init our vue application.
window.configMgr.fetchConfig(initVue);

window.browser = detect();

// handle the case where we don't detect the browser
if (browser) {
  console.log(`System info: ${browser.os} ${browser.name} ${browser.version} `);
}

// Main Vue component
var vm;

Vue.directive('hoverable-action', {
  bind(el, binding, vnode) {
    EventBus.$emit('hoverable-clicked-event', binding.value);
  }
});

// Global utilities for the entire app.
Vue.mixin({
  methods: {
    getAppLevelSetting(key) {
      return window.configMgr.getConfig()[key];
    },
    handleAction(hoverable) {
      EventBus.$emit('hoverable-clicked-event', hoverable);
    },
  }
})

// Vue.config.errorHandler = function VueErrorHandler(error, vm, info) {
//   debugger;
//
//   console.error('call::VueErrorHandler, error.stack:', error.stack)
//   console.error('call::VueErrorHandler, vm:', vm)
//   console.error('call::VueErrorHandler, info:', info)
// };

/* eslint-disable no-new */
function initVue() {
  vm = new Vue({
    el: '#app',
    store,
    router: router,
    render: (h) => h(App),
    // template: '<App/>',
    // components: {App},
    create() {

    },
    mounted() {
      // Remove splash screen after enter route
      document.getElementById('splash-screen-container').style.visibility = 'hidden';

      // route testing here
      // router.push({ path: '/portfolio'} );
      // router.push({ name: 'VRPlayer', query: {player: 'public', sourceId: ""}})
      // router.push({ path: '/vr-player', query: { a: 'private', b: 'public'}})
      // router.push({ name: 'HybridCompactSwitchgear' })
    },
    methods: {

    }
  })
  ;
  window.app = vm;
  window.debug = window.configMgr.getConfig()['debug'];
}



// WEBPACK FOOTER //
// ./src/main.js